import { useLandingContactViewModel } from "@/features/auth/viewmodel/useLandingContactViewModel";
import { Gifs } from "@/assets/gifs";
import styles from "./contactAndDownload.module.css";

export const ContactAndDownload = () => {
  const { isSubmitting, handleSubmit } = useLandingContactViewModel();

  return (
    <div className={styles.contactWrapper}>
      {/* CONTACT SECTION */}
      <section className={styles.contactSection}>
        {/* TOP WAVE */}
        <div className={styles.waveTop} aria-hidden="true">
          <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
            <path d="M0,75 C360,-20 1080,170 1440,75 L1440,0 L0,0 Z" fill="currentColor" />
          </svg>
        </div>

        <div className={styles.contactLeft}>
          <h2 className={styles.contactHeading}>Send A Message</h2>
          <p className={styles.contactSubheading}>
            Fill out the form and our team will get
            <br /> back to you as quickly as we can.
          </p>

          <div className={styles.verticalBox} aria-hidden="true">
            <img
              className={styles.verticalAnimation}
              src={Gifs.andyBio}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        <div className={styles.contactRight}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.formGrid}>
              <div className={styles.inputGroup}>
                <label htmlFor="contactFullName">Full name</label>
                <input id="contactFullName" name="fullName" placeholder="Your full name" />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="contactEmail">E-mail</label>
                <input
                  id="contactEmail"
                  name="email"
                  type="email"
                  inputMode="email"
                  placeholder="Your Email"
                />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="contactPhone">Phone Number</label>
                <input
                  id="contactPhone"
                  name="phone"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  placeholder="98765432"
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                />
              </div>

              <div className={styles.inputGroup}>
                <label htmlFor="contactLocation">Location</label>
                <input id="contactLocation" name="location" placeholder="City, State" />
              </div>
            </div>

            <div className={`${styles.inputGroup} ${styles.full}`}>
              <label htmlFor="contactMessage">Message</label>
              <textarea id="contactMessage" name="message" placeholder="Type your message here" />
            </div>

            <button className={styles.sendBtn} type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send message"}
            </button>
          </form>
        </div>
      </section>

      {/* DOWNLOAD SECTION */}
      <section className={styles.downloadSection}>
        {/* TOP WAVE */}
        <div className={`${styles.waveTop} ${styles.waveTopDownload}`} aria-hidden="true">
          <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
            <path d="M0,75 C360,-20 1080,170 1440,75 L1440,0 L0,0 Z" fill="currentColor" />
          </svg>
        </div>

        <div className={styles.downloadLeft}>
          <h2 className={styles.downloadHeading}>Download the app now!</h2>
          <p className={styles.downloadSubheading}>
            Experience the first ever Automated Protest Filing With Andy
          </p>

          <div className={styles.storeButtons}>
            <a
              href="https://play.google.com/store/apps/details?id=com.theandyapp.andy"
              target="_blank"
              rel="noreferrer"
              aria-label="Open Google Play listing for The Andy App"
            >
              <img
                loading="lazy"
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/the-andy-app/id6746419501"
              target="_blank"
              rel="noreferrer"
              aria-label="Open App Store listing for The Andy App"
            >
              <img
                loading="lazy"
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
              />
            </a>
          </div>
        </div>

        {/* <div className={styles.downloadRight}>
          <div className={styles.qrBox}>
            <img
              loading="lazy"
              src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://example.com"
              alt="QR code"
              width={200}
              height={200}
            />
          </div>
        </div> */}
      </section>
    </div>
  );
};
